module.exports = __webpack_public_path__ + "static/media/max-600-hero.28976510.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/max-600-hero.jpg
// module id = 44
// module chunks = 0